import { FLAGS } from '@/flags';
import { EEnterpriseRole, type IUserProfile } from '@/service/auth/types';

/**
 * 是否为企业管理员。
 *
 * 不放在 `src/service/auth/` 下：那里是接口层，而这是个不发请求的纯谓词，
 * 还要读 feature flag——两样都不该出现在接口层。
 *
 * 一并折进 `ENABLE_TEAM`，功能未开启时不认任何人是管理员：`/portal` 与 `/admin/*`
 * 整棵子树本来就按同一个 flag 注册，若这里不看 flag，关掉功能后 `defaultLandingPath`
 * 与 `UserPopup` 会指向压根没注册的路由。
 */
export const isEnterpriseAdmin = (profile: IUserProfile) =>
  FLAGS.FEATURES.ENABLE_TEAM && profile.enterprise?.memberRole === EEnterpriseRole.Admin;
